export default {
  total_orders: {
    title: 'Zamówienia',
    orders: 'Zamówienia:',
    sales_volume: 'Obrót:',
    delivery_costs: 'Koszty dostawy:',
  },
  cash_orders: {
    title: 'Płatność gotówką / przy drzwiach',
    orders: 'Zamówienia:',
    sales_volume: 'Obrót:',
    delivery_costs: 'Koszty dostawy:',
  },
  online_orders: {
    title: 'Płatności online',
    orders: 'Zamówienia:',
    sales_volume: 'Obrót:',
    delivery_costs: 'Koszty dostawy:',
  },
  total: 'Suma',
  collected_taxes_list: {
    title: {
      online: 'Płatność online',
      cash: 'Płatność gotówką',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Produkt',
          quantity: 'Ilość',
          total: 'Suma',
        },
        labels: {
          total_refunded: 'Zwrócono',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'Podatek %',
          product_type: 'Typ',
          netto: 'Netto',
          tax: 'Podatek',
          brutto: 'Suma',
        },
        product_types: {
          product: 'Produkty {{percentage}}%',
          order_method_fee: 'Opłaty za dostawę {{percentage}}%',
          customer_service_fee: 'Dopłata online',
        },
      },
    },
  },
};
